import styles from './Priceintro.module.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import img1 from '../../assets/imgs/Image2.png';
import img2 from '../../assets/imgs/Image1.png';
import vec1 from '../../assets/icons/vec1.png';
import border from '../../assets/icons/border.png';




export const Priceintro = () => {
  return (
    <div>
        <Container className={`${styles.section}`}>
            <Row>
                <Col lg={6} md={6} sm={12} xs={12}>
                <div>
                    <h2 className={`${styles.Title}`}>Create websites and mobile apps for 
                    your small business at low costs.</h2>
                    <p className={`mb-lg-3 ${styles.desc}`}>If you are a small business and need help getting online
                    at a budget, there are 100s of programmers here to help 
                    you build your first website, e-commerce store, or 
                    mobile app or web application and they work
                    according to your budget.</p>

                    <Button variant='primary' className={`${styles.btn1}`} >See our pricing model <img src={vec1} /></Button>
                </div>
                </Col>

                <Col lg={6} md={6} sm={12} xs={12}>
                    <Row className={`ms-lg-5 ${styles.col2}`}>
                    <Col>
                    {/* <img src={border} className={`${styles.border}`} />  */}
                    <img src={img1} alt='Pricing-image' className={`${styles.img1}`} />
                    </Col>

                    <Col>
                    <img src={img2} alt='Pricing-image' className={`${styles.img2}`} />
                    </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    </div>
  )
}
